module.exports = __webpack_public_path__ + "static/media/close_green_corner.c164cf0a.svg";